import { useCallback, useEffect, useMemo, useState } from 'react';
import { OptionKey, SpendPeriodType } from '@common-fe/common-fe';

import { useGetSpendLimitPeriod } from '../../SpendPeriodTracker/hooks';

interface UseSpendLimitsPeriodParams {
  accountId: string;
}

export const useSpendLimitsPeriod = ({ accountId }: UseSpendLimitsPeriodParams) => {
  const [selectedPeriod, setSelectedPeriod] = useState<OptionKey>('');

  const {
    formattedData: periodData,
    isLoading: isPeriodLoading,
    planYearOptions,
    monthOptions,
    defaultPeriod,
  } = useGetSpendLimitPeriod(accountId);

  const spendPeriodType = periodData?.spendPeriodType as SpendPeriodType | undefined;

  const showPeriodDropdown = useMemo(
    () => spendPeriodType === SpendPeriodType.PLAN_YEAR || spendPeriodType === SpendPeriodType.MONTHLY,
    [spendPeriodType]
  );

  const periodOptions = useMemo(() => {
    if (spendPeriodType === SpendPeriodType.PLAN_YEAR) return planYearOptions;
    if (spendPeriodType === SpendPeriodType.MONTHLY) return monthOptions;
    return [];
  }, [spendPeriodType, planYearOptions, monthOptions]);

  const isPeriodReady = Boolean(selectedPeriod);

  useEffect(() => {
    if (defaultPeriod) {
      setSelectedPeriod(defaultPeriod);
    }
  }, [defaultPeriod]);

  const handlePeriodChange = useCallback((value: OptionKey) => {
    setSelectedPeriod(value);
  }, []);

  return {
    showPeriodDropdown,
    periodOptions,
    selectedPeriod,
    handlePeriodChange,
    isPeriodLoading,
    isPeriodReady,
  };
};
